module.exports = __webpack_public_path__ + "img/login_logo.6856d8f0.png";